module.exports = __webpack_public_path__ + "img/20200609_114526.1d03ac40.jpg";